export const FALLBACK_PARTNER_LOGO =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="42"%3E%3Crect width="80" height="42" fill="%23E1DDD1"/%3E%3C/svg%3E';

export const DEFAULT_CTA_LABEL = 'Learn more';
export const DEFAULT_VIEW_ALL_LABEL = 'View all programs';
export const DEFAULT_VIEW_ALL_HREF = 'https://www.edx.org/search';
export const DEFAULT_TITLE = 'Recommended for you';
